module.exports = __webpack_public_path__ + "img/img3-4.40ff32b0.png";